import script from "./DatasetUI.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetUI.vue?vue&type=script&setup=true&lang=js"

import "./DatasetUI.vue?vue&type=style&index=0&id=d29a65ca&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d29a65ca"]])

export default __exports__